import React, { useEffect, useState } from 'react';
import { Box, Grid } from '@mui/material';
import { Container } from 'reactstrap';
import PageNavigationCard from '../common/PageNavigationCard';
import PageHeader from '../common/PageHeader';
import { PageDetails } from './config';

export const MonarchMind = () => {
  const id = 'monarch-mind';
  const [pageDetails, setPageDetails] = useState({});
  const [monarchMindPages, setMonarchMindPages] = useState([]);

  useEffect(() => {
    loadCurrentPageDetails();
    loadSubPages();
  }, []);

  //θ(N) where N is the number of pages
  //Search for current page details and set in state
  const loadCurrentPageDetails = () => {
    const pageDetails = PageDetails[id];

    setPageDetails(pageDetails);
  };

  //θ(N) where N is the number of pages
  //Get all subpages and set in state
  const loadSubPages = () => {
    const pages = { ...PageDetails };
    delete pages[id];
    setMonarchMindPages(Object.values(pages));
  };

  return (
    <div id={`${id}__div_pageWrapper`} className={`myOdu__${id}`}>
      <Container id={`${id}__container_pageWrapper`} className="myOdu__container secondaryPage">
        <PageHeader
          id={id}
          title={pageDetails?.title}
          logo={pageDetails?.logo}
          pageConfig={{ ...PageDetails }}
        />
        <Box id={`${id}__box_wrapper`} className={'wrapper'}>
          <Grid
            container
            spacing={2}
            alignItems="stretch"
            className="mb-6"
            id={`${id}__stack_ai_wrapper`}
          >
            {monarchMindPages.map((item, index) => {
              return (
                <Grid item lg={12} xl={6} id={`${id}__stack_ai_${index}`}>
                  <PageNavigationCard
                    url={pageDetails?.url}
                    id={id}
                    subPage={item}
                    header={'h4'}
                    cardClass={item.cardClass}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </Container>
    </div>
  );
};
